'use client'

import localFont from "next/font/local";
import "./globals.css";
import { ThemeProvider } from "@/components/theme-provider";
import { Bangers } from 'next/font/google'
import { CookieConsentProvider } from "@/components/cookie-consent";
import { CookiePolicy } from "@/components/CookiePolicy";
import '@/styles/seasonal.css'
import { CSPostHogProvider } from "./providers";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { useTheme } from "next-themes";
import { useEffect } from "react";

const geistSans = localFont({
  src: "./fonts/GeistVF.woff",
  variable: "--font-geist-sans",
  weight: "100 900",
});
const geistMono = localFont({
  src: "./fonts/GeistMonoVF.woff",
  variable: "--font-geist-mono",
  weight: "100 900",
});

const bangers = Bangers({
  weight: '400',
  subsets: ['latin'],
  variable: '--font-bangers',
})

function ThemeColorManager() {
  const { theme } = useTheme()

  useEffect(() => {
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) {
      meta.setAttribute('content', theme === 'dark' ? '#111827' : '#ffffff')
    }
  }, [theme])

  return null
}

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en" suppressHydrationWarning>
      <head>
        <title>Rocket Online Schools (ROCS) Free K-12 Online School</title>
        <meta name="theme-color" content="#ffffff" />
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        <script 
          defer 
          data-domain="rocs.org" 
          src="https://plausible.io/js/script.js"
        />
        <SpeedInsights />
      </head>
      <body
        className={`${geistSans.variable} ${geistMono.variable} antialiased ${bangers.variable}`}
        suppressHydrationWarning
      >
        <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:bg-white focus:text-black p-2 dark:focus:bg-gray-800 dark:focus:text-white">
          Skip to main content
        </a>
        <CSPostHogProvider>
          <ThemeProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            disableTransitionOnChange
          >
            <ThemeColorManager />
            <CookieConsentProvider />
            <CookiePolicy />
            {children}
          </ThemeProvider>
        </CSPostHogProvider>
      </body>
    </html>
  );
}
